import { notification } from "antd";
import sockets from "../../../../socket/socket";
import http from "../../../../api/http";


const socket = sockets;

export const NOTIFY_SET_OPEN = "NOTIFY_SET_OPEN";
export const NOTIFY_SET_FILTER = "NOTIFY_SET_FILTER";

export const NOTIFY_FETCH_REQUEST = "NOTIFY_FETCH_REQUEST";
export const NOTIFY_FETCH_SUCCESS = "NOTIFY_FETCH_SUCCESS";
export const NOTIFY_FETCH_FAIL = "NOTIFY_FETCH_FAIL";

export const NOTIFY_PATCH_ONE = "NOTIFY_PATCH_ONE";
export const NOTIFY_MARK_ALL_READ = "NOTIFY_MARK_ALL_READ";
export const NOTIFY_REMOVE_ONE = "NOTIFY_REMOVE_ONE";
export const NOTIFY_CLEAR_ALL = "NOTIFY_CLEAR_ALL";

export const NOTIFY_DELETE_ALL_REQUEST = "NOTIFY_DELETE_ALL_REQUEST";
export const NOTIFY_DELETE_ALL_FINISH = "NOTIFY_DELETE_ALL_FINISH";

export const NOTIFY_SET_DECISION = "NOTIFY_SET_DECISION";
export const NOTIFY_SET_DECISION_LOADING = "NOTIFY_SET_DECISION_LOADING";
export const NOTIFY_CLEAR_DECISION = "NOTIFY_CLEAR_DECISION";

const stringBool = (value) => String(value) === "true";

const getNotifyId = (item) => item?._id || null;

// «Не прочитано» хранится в поле unread. Старое isUnread создавалось false и
// переключалось туда-обратно, ему не верим.
export const isNotifyUnread = (item) => item?.unread === true;

const normalizeItems = (items) => {
  if (!Array.isArray(items)) return [];

  return items
    .filter(Boolean)
    .sort((a, b) => {
      if (isNotifyUnread(a) === isNotifyUnread(b)) return 0;
      return isNotifyUnread(a) ? -1 : 1;
    });
};

const getContext = (getState) => {
  const state = getState();

  return {
    companyId: state?.checkedSessionReducer?.checkedSession || "",
    userId: state?.getMayInfoReducer?.myinfo?._id || "",
  };
};

const emitRefresh = (getState, fallback) => {
  const { companyId, userId } = getContext(getState);
  const payload = { companyId, userId };

  if (socket.connected) {
    socket.timeout(3000).emit("getNotifyEmit", payload, (err, ok) => {
      if (err || ok !== true) {
        fallback?.();
      }
    });
  } else {
    fallback?.();
  }
};

const emitTaskRefresh = (getState) => {
  const { companyId } = getContext(getState);

  if (!companyId) return;

  socket.emit("message", { room: companyId });
  socket.emit("getAllTask", { companyIDS: companyId });
  socket.emit("getallTaskforUpdateServer");
};

export const openNotifyDrawer = () => ({
  type: NOTIFY_SET_OPEN,
  payload: true,
});

export const closeNotifyDrawer = () => ({
  type: NOTIFY_SET_OPEN,
  payload: false,
});

export const setNotifyFilter = (value) => ({
  type: NOTIFY_SET_FILTER,
  payload: value,
});

export const fetchNotifications =
  ({ silent = false, force = false } = {}) =>
  async (dispatch, getState) => {
    const notifyState = getState()?.NotifyCenterReducer;

    if (!force && (notifyState?.loading || notifyState?.refreshing)) {
      return;
    }

    const now = Date.now();
    if (
      !force &&
      silent &&
      notifyState?.lastFetchAt &&
      now - notifyState.lastFetchAt < 800
    ) {
      return;
    }

    dispatch({
      type: NOTIFY_FETCH_REQUEST,
      payload: { silent },
    });

    try {
      const res = await http.get("/notifyConfirm", {
        headers: {
          "Cache-Control": "no-store",
          Pragma: "no-cache",
        },
      });

      dispatch({
        type: NOTIFY_FETCH_SUCCESS,
        payload: normalizeItems(res?.data?.data),
      });
    } catch (error) {
      dispatch({
        type: NOTIFY_FETCH_FAIL,
        payload:
          error?.response?.data?.message ||
          error?.message ||
          "Не удалось загрузить уведомления",
      });
    }
  };

export const markNotificationRead = (item) => async (dispatch, getState) => {
  const notifyId = getNotifyId(item);
  if (!notifyId) return;

  dispatch({
    type: NOTIFY_PATCH_ONE,
    payload: {
      id: notifyId,
      patch: { unread: false, isUnread: false },
    },
  });

  try {
    await http.patch("/api/notificationRead/", { id: notifyId });
    emitRefresh(getState, () =>
      dispatch(fetchNotifications({ silent: true, force: true }))
    );
  } catch (error) {
    console.error("markNotificationRead failed", error);
    dispatch(fetchNotifications({ silent: true, force: true }));
  }
};

export const markAllNotificationsRead = () => async (dispatch, getState) => {
  const hasUnread = (getState()?.NotifyCenterReducer?.items || []).some(isNotifyUnread);
  if (!hasUnread) return;

  dispatch({ type: NOTIFY_MARK_ALL_READ });

  try {
    await http.post("/api/notifications/read-all");
  } catch (error) {
    console.error("markAllNotificationsRead failed", error);
    dispatch(fetchNotifications({ silent: true, force: true }));
  }
};

export const deleteNotification = (item) => async (dispatch, getState) => {
  const notifyId = getNotifyId(item);
  if (!notifyId) return;

  dispatch({
    type: NOTIFY_REMOVE_ONE,
    payload: notifyId,
  });

  dispatch({
    type: NOTIFY_CLEAR_DECISION,
    payload: notifyId,
  });

  try {
    await http.post("/handleDelete/api", {
      itemID: notifyId,
    });

    emitRefresh(getState, () =>
      dispatch(fetchNotifications({ silent: true, force: true }))
    );
  } catch (error) {
    console.error("deleteNotification failed", error);
    dispatch(fetchNotifications({ silent: true, force: true }));
  }
};

export const deleteAllNotifications = () => async (dispatch, getState) => {
  const items = getState()?.NotifyCenterReducer?.items || [];
  if (!items.length) return;

  try {
    dispatch({ type: NOTIFY_DELETE_ALL_REQUEST });

    const notifyID = items.map((n) => n?._id).filter(Boolean);
    await http.post("/deletAllNotification/api", { notifyID });

    dispatch({ type: NOTIFY_CLEAR_ALL });

    emitTaskRefresh(getState);
    emitRefresh(getState, () =>
      dispatch(fetchNotifications({ silent: true, force: true }))
    );
  } catch (error) {
    console.error("deleteAllNotifications failed", error);
    dispatch(fetchNotifications({ silent: true, force: true }));
  } finally {
    dispatch({ type: NOTIFY_DELETE_ALL_FINISH });
  }
};

export const applyNotificationDecision =
  (item, mode) => async (dispatch, getState) => {
    const notifyId = getNotifyId(item);
    if (!notifyId) return;

    try {
      dispatch({
        type: NOTIFY_SET_DECISION_LOADING,
        payload: { id: notifyId, value: true },
      });

      const taskDoc = JSON.parse(
        JSON.stringify(item?.alltask?.[0]?.[0] || null)
      );
      if (!taskDoc) return;

      const isChild = stringBool(item?.isChild);
      const mainTask = taskDoc?.alltask?.[0];
      if (!mainTask) return;

      if (item?.typenotify === "date") {
        if (isChild) {
          if (!mainTask?.child?.[item.indexTask]) return;
          mainTask.child[item.indexTask].endDate =
            mode === "apply" ? item.messageConfirm : item.oldDate;
        } else {
          mainTask.endDate =
            mode === "apply" ? item.messageConfirm : item.oldDate;
        }
      }

      if (item?.typenotify === "status") {
        if (isChild) {
          if (!mainTask?.child?.[item.indexTask]) return;
          mainTask.child[item.indexTask].status =
            mode === "apply" ? "Закрыта" : "Возвращена";
        } else {
          mainTask.status = mode === "apply" ? "Закрыта" : "Возвращена";
        }
      }

      const payload = {
        idTask: taskDoc._id,
        alltask: taskDoc.alltask,
        pushItemID: item._id,
        adminID: item.adminIDTask,
        senderEmail: item.senderEmail,
        isChild: item.isChild,
        index: isChild ? item.indexTask : 0,
        task: taskDoc,
      };

      // Решение по просьбе = уведомление прочитано.
      http.patch("/api/notificationRead/", { id: notifyId }).catch(() => {});

      if (mode === "apply") {
        await http.post("/handleapply/api", payload);

        dispatch({
          type: NOTIFY_SET_DECISION,
          payload: { id: notifyId, value: "approved" },
        });

        dispatch({
          type: NOTIFY_PATCH_ONE,
          payload: {
            id: notifyId,
            patch: {
              statusNotify: "Подтверждено",
              unread: false,
              isUnread: false,
            },
          },
        });
      } else {
        await http.post("/handleCanchel/api", payload);

        dispatch({
          type: NOTIFY_SET_DECISION,
          payload: { id: notifyId, value: "rejected" },
        });

        dispatch({
          type: NOTIFY_PATCH_ONE,
          payload: {
            id: notifyId,
            patch: {
              statusNotify: "Отменено",
              unread: false,
              isUnread: false,
            },
          },
        });
      }

      emitTaskRefresh(getState);
      emitRefresh(getState, () =>
        dispatch(fetchNotifications({ silent: true, force: true }))
      );
    } catch (error) {
      console.error("applyNotificationDecision failed", error);
      notification.error({
        message: "Ошибка",
        description: "Не удалось изменить статус подтверждения.",
      });
      dispatch(fetchNotifications({ silent: true, force: true }));
    } finally {
      dispatch({
        type: NOTIFY_SET_DECISION_LOADING,
        payload: { id: notifyId, value: false },
      });
    }
  };